export type DocumentLanguage = "pt-PT" | "en";

/**
 * The `<html lang>` a URL path should carry before any page has said otherwise: "pt-PT" for the
 * Portuguese site (`/pt` and everything under `/pt/`), "en" for everything else.
 *
 * This is the same rule the rest of the app uses to tell a Portuguese address from an English one
 * (`defaultAlternates` in Seo, `NotFoundPage`, the header's `LanguageSwitcher`): the exact `/pt` or
 * the `/pt/` prefix, so `/ptx` is not Portuguese. Pass a pathname, not a full URL - the query string
 * and hash are not part of it.
 *
 * A page can still override this with its own `<Seo lang>`, which is how a standalone Portuguese
 * blog post at an English-looking path (`/blog/<ptSlug>`) ends up `pt-PT`.
 */
export function languageForPath(pathname: string): DocumentLanguage {
    return pathname === "/pt" || pathname.startsWith("/pt/") ? "pt-PT" : "en";
}
